import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class BrandGroups extends Component {
    constructor() {
        super()
        this.state = {
            BrandGroupsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getBrandGroupsListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getBrandGroupsListData = () => {
        apiService.getBrandGroupsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            BrandGroupsList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from BrandGroups list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.BrandGroupsList).map((value,index) => {
            return {
                label : this.state.BrandGroupsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Brand Group"
                onChange={(e) => { (e) ? this.props.brandGroupChange(e) : this.props.brandGroupChange([])}}
                />
            </div>
        )
    }
}

export default BrandGroups


// WEBPACK FOOTER //
// ./src/modules/Brands/Components/DropDowns/BrandGroups.js